import React, { useRef, useEffect, useState } from 'react';
import { DataView } from 'primereact/dataview';
import { useHistory } from "react-router-dom";
import { Toast } from 'primereact/toast';
import '../layout/sass/_pickListSugestoes.scss'
import { Button } from 'primereact/button';
import '../layout/sass/_responsiveTable.scss';
import { DialogDashboard } from './DialogDashboard';

export const TabelaDashboard = (props) => {
    const toast = useRef(null);
    const confirmationToast = useRef(null)
    const [buscaData, setBuscaData] = useState({});
    const history = useHistory();
    const [showListaPedras, setShowListaPedras] = useState(false);

    useEffect(() => {
        setBuscaData(props.buscaDatas);
    }, [props])


    const dataPedras = {
        dataEmissao: props.data.dataEmissao,
    }

    const handleRequest = (pedraNumero) => {

        history.push({
            pathname: `/romaneiocreate`,
            dados: {
                'pedraNumero': pedraNumero,
                'dataEmissao': props.data.dataEmissao
            }
        });
    };

    const numeroBodyTemplate = (rowData) => {
        return (
            <>
                <div className="col-12 md:col-4">
                    {rowData.uso === true ?
                        <>
                            <div style={{ marginBottom: '24px' }}>
                                {rowData.numero <= 84 ?
                                    <>
                                        {rowData.numero % 2 !== 0 ?
                                            <Button style={{
                                                'border': '1px solid white',
                                                'backgroundColor': 'red',
                                                'width': '34px',
                                                'height': '34px',
                                                'textAlign': 'center',
                                                'margin': '0px',
                                                'color': "white",
                                                'padding': '9px',
                                                'textDecoration': rowData.ocupacao === "avulsa" ? 'underline' : 'normal'
                                            }}
                                                tooltip={rowData.ocupante}
                                                tooltipOptions={{ position: 'top' }}>

                                                {rowData.numero}

                                            </Button>
                                            : <><br /><br /></>}
                                        {rowData.numero % 2 === 0 ?
                                            <Button style={{
                                                'border': '1px solid white',
                                                'backgroundColor': 'red',
                                                'width': '34px',
                                                'height': '34px',
                                                'textAlign': 'center',
                                                'margin': '0px 0 0 -34px',
                                                'color': "white",
                                                'padding': '9px',
                                                'textDecoration': rowData.ocupacao === "avulsa" ? 'underline' : 'normal'
                                            }}
                                                tooltip={rowData.ocupante}
                                                tooltipOptions={{ position: 'top' }}>

                                                {rowData.numero}

                                            </Button>
                                            : <></>}
                                        {rowData.numero === 28 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                        {rowData.numero === 56 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                        {rowData.numero === 84 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                    </>
                                    :
                                    <></>}
                            </div>
                        </>
                        :
                        <>
                            <div style={{ marginBottom: '24px' }}>
                                {rowData.numero <= 84 ?
                                    <>
                                        {rowData.numero % 2 !== 0 ?
                                            <Button style={{
                                                'border': '1px solid white',
                                                'backgroundColor': 'green',
                                                'width': '34px',
                                                'height': '34px',
                                                'textAlign': 'center',
                                                'margin': '0px',
                                                'color': "white",
                                                'padding': '9px'
                                            }}
                                                onClick={() => handleRequest(rowData)}
                                                tooltip={rowData.numero}
                                                tooltipOptions={{ position: 'top' }}>

                                                {rowData.numero}

                                            </Button>
                                            : <><br /><br /></>}
                                        {rowData.numero % 2 === 0 ?
                                            <Button style={{
                                                'border': '1px solid white',
                                                'backgroundColor': 'green',
                                                'width': '34px',
                                                'height': '34px',
                                                'textAlign': 'center',
                                                'margin': '0px 0 0 -34px',
                                                'color': "white",
                                                'padding': '9px'
                                            }}
                                                onClick={() => handleRequest(rowData)}
                                                tooltip={rowData.numero}
                                                tooltipOptions={{ position: 'top' }}>

                                                {rowData.numero}

                                            </Button>
                                            : <></>}

                                        {rowData.numero === 28 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                        {rowData.numero === 56 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                        {rowData.numero === 84 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                    </>
                                    :
                                    <></>}
                            </div>
                        </>
                    }

                </div>



            </>
        );
    }

    const numero2BodyTemplate = (rowData) => {
        return (
            <div className="col-12 md:col-4">
                {rowData.uso === true ?
                    <>
                        <div style={{ marginBottom: '24px' }}>
                            {rowData.numero >= 85 && rowData.numero <= 168 ?
                                <>
                                    {rowData.numero % 2 !== 0 ?
                                        <Button style={{
                                            'border': '1px solid white',
                                            'backgroundColor': 'red',
                                            'width': '34px',
                                            'height': '34px',
                                            'textAlign': 'center',
                                            'margin': '0px',
                                            'color': "white",
                                            'padding': '5px',
                                            'textDecoration': rowData.ocupacao === "avulsa" ? 'underline' : 'normal'
                                        }}
                                            tooltip={rowData.ocupante}
                                            tooltipOptions={{ position: 'top' }}>

                                            {rowData.numero}

                                        </Button>
                                        : <><br /><br /></>}
                                    {rowData.numero % 2 === 0 ?
                                        <Button style={{
                                            'border': '1px solid white',
                                            'backgroundColor': 'red',
                                            'width': '34px',
                                            'height': '34px',
                                            'textAlign': 'center',
                                            'margin': '0px 0 0 -34px',
                                            'color': "white",
                                            'padding': '5px',
                                            'textDecoration': rowData.ocupacao === "avulsa" ? 'underline' : 'normal'
                                        }}
                                            tooltip={rowData.ocupante}
                                            tooltipOptions={{ position: 'top' }}>

                                            {rowData.numero}

                                        </Button>
                                        : <></>}
                                    {rowData.numero === 112 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                    {rowData.numero === 140 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                    {rowData.numero === 168 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                </>
                                :
                                <></>}
                        </div>
                    </>
                    :
                    <>
                        <div style={{ marginBottom: '24px' }}>
                            {rowData.numero >= 85 && rowData.numero <= 168 ?
                                <>
                                    {rowData.numero % 2 !== 0 ?
                                        <Button style={{
                                            'border': '1px solid white',
                                            'backgroundColor': 'green',
                                            'width': '34px',
                                            'height': '34px',
                                            'textAlign': 'center',
                                            'margin': '0px',
                                            'color': "white",
                                            'padding': '5px'
                                        }}
                                            onClick={() => handleRequest(rowData)}
                                            tooltip={rowData.numero}
                                            tooltipOptions={{ position: 'top' }}>

                                            {rowData.numero}

                                        </Button>
                                        : <><br /><br /></>}
                                    {rowData.numero % 2 === 0 ?
                                        <Button style={{
                                            'border': '1px solid white',
                                            'backgroundColor': 'green',
                                            'width': '34px',
                                            'height': '34px',
                                            'textAlign': 'center',
                                            'margin': '0px 0 0 -34px',
                                            'color': "white",
                                            'padding': '5px'
                                        }}
                                            onClick={() => handleRequest(rowData)}
                                            tooltip={rowData.numero}
                                            tooltipOptions={{ position: 'top' }}>

                                            {rowData.numero}

                                        </Button>
                                        : <></>}
                                    {rowData.numero === 112 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                    {rowData.numero === 140 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                    {rowData.numero === 168 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                </>
                                :
                                <></>}
                        </div>
                    </>
                }

            </div>
        );
    }


    const numero3BodyTemplate = (rowData) => {
        return (
            <div className="col-12 md:col-4">
                {rowData.uso === true ?
                    <>
                        <div style={{ marginBottom: '24px' }}>
                            {rowData.numero >= 169 && rowData.numero <= 252 ?
                                <>
                                    {rowData.numero % 2 !== 0 ?
                                        <Button style={{
                                            'border': '1px solid white',
                                            'backgroundColor': 'red',
                                            'width': '34px',
                                            'height': '34px',
                                            'textAlign': 'center',
                                            'margin': '0px',
                                            'color': "white",
                                            'padding': '5px',
                                            'textDecoration': rowData.ocupacao === "avulsa" ? 'underline' : 'normal'
                                        }}
                                            tooltip={rowData.ocupante}
                                            tooltipOptions={{ position: 'top' }}>

                                            {rowData.numero}

                                        </Button>
                                        : <><br /><br /></>}
                                    {rowData.numero % 2 === 0 ?
                                        <Button style={{
                                            'border': '1px solid white',
                                            'backgroundColor': 'red',
                                            'width': '34px',
                                            'height': '34px',
                                            'textAlign': 'center',
                                            'margin': '0px 0 0 -34px',
                                            'color': "white",
                                            'padding': '5px',
                                            'textDecoration': rowData.ocupacao === "avulsa" ? 'underline' : 'normal'
                                        }}
                                            tooltip={rowData.ocupante}
                                            tooltipOptions={{ position: 'top' }}>

                                            {rowData.numero}

                                        </Button>
                                        : <></>}
                                    {rowData.numero === 196 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                    {rowData.numero === 224 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                    {rowData.numero === 252 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                </>
                                :
                                <></>}
                        </div>
                    </>
                    :
                    <>
                        <div style={{ marginBottom: '24px' }}>
                            {rowData.numero >= 169 && rowData.numero <= 252 ?
                                <>
                                    {rowData.numero % 2 !== 0 ?
                                        <Button style={{
                                            'border': '1px solid white',
                                            'backgroundColor': 'green',
                                            'width': '34px',
                                            'height': '34px',
                                            'textAlign': 'center',
                                            'margin': '0px',
                                            'color': "white",
                                            'padding': '5px'
                                        }}
                                            onClick={() => handleRequest(rowData)}
                                            tooltip={rowData.numero}
                                            tooltipOptions={{ position: 'top' }}>

                                            {rowData.numero}

                                        </Button>
                                        : <><br /><br /></>}
                                    {rowData.numero % 2 === 0 ?
                                        <Button style={{
                                            'border': '1px solid white',
                                            'backgroundColor': 'green',
                                            'width': '34px',
                                            'height': '34px',
                                            'textAlign': 'center',
                                            'margin': '0px 0 0 -34px',
                                            'color': "white",
                                            'padding': '5px'
                                        }}
                                            onClick={() => handleRequest(rowData)}
                                            tooltip={rowData.numero}
                                            tooltipOptions={{ position: 'top' }}>

                                            {rowData.numero}

                                        </Button>
                                        : <></>}
                                    {rowData.numero === 196 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                    {rowData.numero === 224 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                    {rowData.numero === 252 ? <div className="p-field p-col-12 p-sm-12"></div> : <></>}
                                </>
                                :
                                <></>}
                        </div>
                    </>
                }

            </div>
        );
    }

    const handlePrintClick = () => {
        setShowListaPedras(true);
    }

    return (
        <>
            {props.buscaDatas ?
                <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">
                    <DialogDashboard
                        visible={showListaPedras}
                        setVisible={setShowListaPedras}
                        pedras={buscaData}
                        pedraPesquisa={dataPedras}
                    />
                    <div className="p-my-0 p-dir-rev p-col">
                        <div className="p-my-0">
                            <Button
                                textalign="center"
                                icon="pi pi-print"
                                className="p-button-secondary"
                                style={{ width: '35px' }}
                                onClick={handlePrintClick}
                                tooltip="Gerar relatório"
                                tooltipOptions={{ position: 'top' }}
                            />
                        </div>
                    </div>
                </div>
                :
                <></>}

            <div className="card p-grid p-col-4 p-mx-0 p-p-0 p-mt-0" style={{ 'width': '492px', 'padding': '0px' }}>
                <Toast ref={toast} position="bottom-right" />
                <Toast ref={confirmationToast} position="bottom-center" />
                <DataView
                    value={buscaData}
                    layout={numeroBodyTemplate}
                    itemTemplate={numeroBodyTemplate}
                    emptyMessage=""
                    style={{ 'padding': '0px' }}
                >
                </DataView>
            </div>

            <div className="card p-grid p-col-4 p-mx-0 p-p-0 p-mt-0" style={{ 'width': '492px', 'padding': '0px' }}>
                <Toast ref={toast} position="bottom-right" />
                <Toast ref={confirmationToast} position="bottom-center" />
                <DataView
                    value={buscaData}
                    layout={numero2BodyTemplate}
                    itemTemplate={numero2BodyTemplate}
                    emptyMessage="Nenhuma pedra encontrada"
                    style={{ 'padding': '0px' }}
                >
                </DataView>
            </div>

            <div className="card p-grid p-col-4 p-mx-0 p-p-0 p-mt-0" style={{ 'width': '492px', 'padding': '0px' }}>
                <Toast ref={toast} position="bottom-right" />
                <Toast ref={confirmationToast} position="bottom-center" />
                <DataView
                    value={buscaData}
                    layout={numero3BodyTemplate}
                    itemTemplate={numero3BodyTemplate}
                    emptyMessage=""
                    style={{ 'width': '495px', 'padding': '0px' }}
                >
                </DataView>
            </div>
        </>
    );
}